module.exports = __webpack_public_path__ + "img/three-3.0dfe3208.jpg";